import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import NotificationContainer from 'bdvp-common/src/containers/Notification';

const Notification = styled(NotificationContainer)`
    margin: 20px 14px 0px;

    ${media.mdmin`
        margin: 20px 16px 0px;
    `}

    ${media.lgmin`
        margin: 20px 32px 0px 20px;
    `}
`;

export default Notification;
